<template>
<div>
  <div class="container is-child">
    <article class="segment">
        <h1 class="has-text-centered">Shot Quality</h1>
        <div class="columns is-centered">
          <div class="column is-2">
            <h2 class="stat-category has-text-centered">{{home_name}}<br ></h2>
            <p class="stat-number has-text-centered">{{home_shots.goals}}</p>
            <p class="stat-number has-text-centered">{{home_shots.xg}}</p>
            <p class="stat-number has-text-centered">{{home_shots.shot_on_target}}</p>
            <p class="stat-number has-text-centered">{{home_shots.shot_attempts}}</p>
            <p class="stat-number has-text-centered">{{home_shots.shooting_percentage}}</p>
          </div>
          <div class="column is-2">
            <h2 class="stat-title has-text-centered">Team <br ></h2>
            <h2 class="stat-title has-text-centered">Goals</h2>
            <h2 class="stat-title has-text-centered">XG</h2>
            <h2 class="stat-title has-text-centered">SOT</h2>
            <h2 class="stat-title has-text-centered">Shot Attempts</h2>
            <h2 class="stat-title has-text-centered">SH%</h2>
          </div>
          <div class="column is-2">
            <h2 class="stat-category has-text-centered">{{away_name}} <br ></h2>
            <p class="stat-number has-text-centered">{{away_shots.goals}}</p>
            <p class="stat-number has-text-centered">{{away_shots.xg}}</p>
            <p class="stat-number has-text-centered">{{away_shots.shot_on_target}}</p>
            <p class="stat-number has-text-centered">{{away_shots.shot_attempts}}</p>
            <p class="stat-number has-text-centered">{{away_shots.shooting_percentage}}</p>
          </div>
        </div>
    </article>
    <!--
    <article class="segment">
      
        <h1 class="title has-text-centered">XG / Time</h1>
        <button class="button is-small is-info" @click="show = !show">Show / Hide</button>
        <div class="columns">
          <div class="column">
            <div class="control">
              <label for="number" class="label">Time Interval</label>
              <input class="input" type="number" min="0" max="20" v-model="interval" @change="fetchShotQuality()">
            </div>
            <div class="control">
              <label for="number" class="label">Fill</label>
              <input type="checkbox" class="checkbox" v-model="fillOption">
            </div>
          </div>
          <div class="column">
            <div class="control">
              <label for="toggle" class="label">Differential</label>
              <input type="checkbox" class="checkbox" v-model="toggleDifferential" @change="fetchShotQuality()">
            </div>
          </div>
        </div>
        <chart :type="'line'" :data="chartData" :options="line_options"></chart>
    </article>
    -->
   </div>
</div>
</template>

<script>
import Chart from 'vue-bulma-chartjs'
import _ from 'lodash'
export default {
  props: ['home_name', 'away_name', 'game_id'],
  components: {
    Chart
  },
  computed: {
    getShotDataHome: function () {
      return _.map(this.ShotData, 'home_diff')
    },
    getShotDataAway: function () {
      return _.map(this.ShotData, 'away_diff')
    },
    chartData: function () {
      let playerLabels = []
      for (var label of this.ShotData) {
        playerLabels.push(label.index)
      }
      let data = {
        labels: playerLabels
      }
      data.datsets = []
      data.datasets = [{
        data: this.getShotDataHome,
        label: this.home_name,
        backgroundColor: 'rgba(54, 162, 235, 1)',
        borderColor: 'rgba(54, 162, 235, 1)',
        pointBackgroundColor: 'rgba(0,0,0,1)',
        lineTension: 0,
        fill: this.fillOption
      },
      {
        data: this.getShotDataAway,
        label: this.away_name,
        backgroundColor: 'rgba(255, 206, 86, 1)',
        pointBackgroundColor: 'rgba(0,0,0,1)',
        borderColor: 'rgba(255, 206, 86, 1)',
        lineTension: 0,
        fill: this.fillOption
      }]
      return data
    }
  },
  data () {
    return {
      home_shots: [],
      away_shots: [],
      ShotData: [],
      fillOption: false,
      toggleDifferential: false,
      headers: [
        'Time',
        '+',
        '-',
        '+/-'
      ],
      interval: 1,
      lines: {
        type: 'line',
        mode: 'vertical',
        scaleID: 'x-axis-0',
        value: '00:40:00',
        borderColor: 'red',
        label: {
          content: '3',
          enabled: true,
          position: 'top'
        }
      },
      line_options: {
        title: {
          display: false,
          text: 'Data Chart'
        },
        tooltips: {
          mode: 'nearest',
          intersect: true,
          position: 'nearest',
          autoSkip: false
        },
        annotation: {
          annotations: []
        },
        responsive: true,
        scaleOverride: true,
        scaleStepWidth: 1,
        scales: {
          xAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              reverse: true
            }
          }],
          yAxes: [{
            stacked: false,
            maxBarThickness: 60,
            ticks: {
              autoSkip: false,
              beginAtZero: true
            }
          }]
        }
      }
    }
  },
  methods: {
    fetchShotQuality () {
      let postData = {
        'game_id': this.game_id
      }
      this.$http
        .post(
          'https://devilsapi.roblutken.com/api/app/get/match-stats/shot-quality', postData,
          { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }
        )
        .then(
          response => {
            // console.log('Faceoff Data is ' + response.data)
            this.home_shots = response.data.home_team
            this.away_shots = response.data.away_team
            this.ShotData = response.data.xg_time
            let lineData = response.data.annotations
            for (var i = 0; i < lineData.length; i++) {
              this.line_options.annotation.annotations.push(lineData[i])
            }
            // console.log(JSON.stringify(this.away_shots))
          },
          response => {}
        )
    }
  },
  created () {
    // console.log('Props' + this.home_name + ' ' + this.away_name + ' id ' + this.game_id)
    this.fetchShotQuality()
  }
}
</script>

<style lang='scss' scoped>
.segment {
  padding-top:1em;
  padding-bottom:2em;
  margin-right: auto;
  margin-left:auto;
  max-width: 98%;
  margin-top:1em;
  padding-left: 1em;
  padding-right: 1em;
  -webkit-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  -moz-box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
  box-shadow:  -2px -1px 10px 3px rgba(112,111,112,.2);
}
.segment h1 {
  color:rgb(39, 39, 39);
  margin-top:0.4em;
  font-weight: 800;
  text-transform: uppercase;
  font-size: 3em;
}
.segment p{
  font-size:1.2em;
  text-transform: uppercase;
}
.stat-title{
  font-family: 'Heebo', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  color:rgb(54, 54, 54);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-category{
  font-family: 'Heebo', sans-serif;
  font-weight: 900;
  text-transform: uppercase;
  color:rgb(29, 29, 29);
  font-size: 1.3rem;
  margin: 1rem 0rem;
}
.stat-number{
  font-family: 'Heebo', sans-serif;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.3rem;
  margin: 1rem 0rem;
  color:black;
}
</style>



// WEBPACK FOOTER //
// shots-quality.vue?0e9caaf0